"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Spanish localization
 */
exports.default = {
    /**
     * Welcome page
     */
    skip: 'Saltar',
    letsStart: 'Empecemos',
    next: 'Siguiente',
    registerNow: 'Regístrate ahora',
    welcome_title_1: 'Descubre la primera billetera basada en NFT',
    welcome_subtitle_1: 'Compra, colecciona e intercambia artículos',
    welcome_title_2: 'Crea tu propia colección de NFT ahora',
    welcome_subtitle_2: 'Compra, colecciona e intercambia artículos',
    welcome_title_3: 'Descubre el emocionante mundo de las criptomonedas',
    welcome_subtitle_3: 'Compra, colecciona e intercambia artículos',
    /**
     * Login and registration page
     */
    login: 'Iniciar sesión',
    welcomeBack: '¡Bienvenido de nuevo, te hemos extrañado!',
    noAccount: '¿No tienes una cuenta?',
    register: 'Registrarse',
    offline: '¡Parece que estás sin conexión!',
    checkConnection: 'Verifica la conexión e intenta nuevamente',
    username: 'Nombre de usuario',
    usernameOrEmail: 'Nombre de usuario o correo electrónico',
    usernameRequired: 'Se requiere nombre de usuario *',
    password: 'Contraseña',
    passwordErrorLength: 'Debe tener al menos 8 caracteres',
    forgotPassword: '¿Olvidaste tu contraseña?',
    byClickingRegister: 'Al hacer clic en "Registrarse", aceptas nuestra',
    privacyNotice: 'Aviso de privacidad',
    termsAndConditions: 'Términos y condiciones.',
    and: 'y',
    accountRemoved: 'Cuenta eliminada',
    accountRemovedMessage: 'Tu cuenta ha sido eliminada exitosamente.',
    /**
     * Reset Password page
     */
    resetPassword: 'Restablecer contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    emailSent: '¡Correo electrónico enviado exitosamente!',
    passwordChanged: 'Contraseña cambiada',
    passwordUpdated: 'Tu contraseña se ha actualizado exitosamente.',
    incorrectPassword: 'Contraseña incorrecta',
    passwordDoesNotMatch: 'La contraseña no coincide. Por favor, inténtalo nuevamente.',
    close: 'Cerrar',
    emailSentTo: 'Se envió un correo electrónico a',
    withLinkTo: 'con un enlace para restablecer tu contraseña.',
    reset: 'Restablecer',
    passwordResetEmailSent: 'Hemos enviado instrucciones para restablecer la contraseña a tu correo electrónico',
    passwordResetEmailNotSent: 'No pudimos enviar instrucciones para restablecer la contraseña',
    resetPasswordNote: 'Nota: Si encontramos la cuenta asociada al correo, recibirás un código para completar el restablecimiento de tu contraseña.',
    backTo: 'Volver a',
    resetPasswordRules: 'Tu contraseña debe tener al menos 8 caracteres y debe incluir una combinación de letras, números y caracteres especiales.',
    /**
     * Enrollment page
     */
    wallet: 'Billetera',
    walletActivationFail: 'Error en la activación de la billetera.',
    walletActivationFailMessage: 'Algo salió mal. Por favor, inténtalo nuevamente más tarde.',
    walletImportSuccess: 'Billetera importada exitosamente',
    walletImportSuccessMsg: 'Tu billetera ha sido importada exitosamente.',
    walletNotActivated: 'Billetera no activada, inténtalo nuevamente',
    important: '¡Importante!',
    walletInfo: 'Tu billetera ha sido activada. Por favor, haz una copia de seguridad de tu billetera y guárdala de forma segura.',
    ok: 'Ok',
    finish: 'Finalizar',
    activationSuccessful: 'Activación exitosa',
    importCertificate: 'Importar Certificado',
    activate: 'Activar',
    reactivate: 'Reactivar',
    activateYourWallet: 'Activa tu billetera',
    reactivateYourWallet: 'Reactiva tu billetera',
    import: 'Importar',
    walletImportFail: 'Fallo al importar la billetera',
    tryWalletImportAgain: 'Por favor, verifica el archivo que seleccionaste para importar y vuelve a intentarlo.',
    yourWalletActivated: 'Tu billetera ha sido activada exitosamente.',
    youWalletActivatedDescription: 'Por favor, mantén tu billetera segura. No la compartas con otros ya que representa tu identidad en la blockchain. Te recomendamos hacer una copia de seguridad de tu billetera en caso de que la pierdas o cambies de dispositivo.',
    activateWalletDescription: 'Para acceder a tus entradas, primero debes activar tu billetera. La activación emite un certificado que demuestra tu propiedad de la entrada.',
    reactivateWalletDescription: 'Para acceder a tus entradas, primero debes reactivar tu billetera. La reactivación emite un certificado que demuestra tu propiedad de la entrada.',
    beSureToBackUp: 'Asegúrate de hacer una copia de seguridad de tu billetera después de la activación.',
    beSureToReBackUp: 'Asegúrate de hacer una copia de seguridad de tu billetera después de la reactivación.',
    youAlreadyActivatedWallet: 'Ya has activado tu billetera. Para acceder a tus entradas, deberás importar tu certificado.',
    importWalletAccessTickets: 'Importa tu billetera para acceder a todas las entradas compradas',
    almostDoneImportingWallet: '¡Casi terminado! Importando tu billetera',
    almostDoneActivatingWallet: '¡Casi terminado! Activando tu billetera',
    almostDoneReactivatingWallet: '¡Casi terminado! Reactivando tu billetera',
    didNotBackUpWallet: 'Si no hiciste una copia de seguridad de tu certificado o perdiste tu teléfono, contacta a soporte @BAMSupport.',
    /**
 * Menu
 */
    myProfile: 'Mi Perfil',
    save: 'Guardar',
    organizer: 'Organizador',
    signout: 'Cerrar Sesión',
    signoutTitle: '¿Estás seguro de que quieres cerrar sesión?',
    signoutMessage: 'Asegúrate de guardar todos los cambios antes de cerrar sesión.',
    applicationSettings: 'Configuración de la Aplicación',
    support: 'Soporte',
    /**
     * Profile page
     */
    account: 'Cuenta',
    personalInformation: 'Información Personal',
    informationUpdated: '¡Información actualizada exitosamente!',
    invalidEmail: 'Se requiere una dirección de correo electrónico válida',
    chooseOption: 'Elegir una opción',
    cancel: 'Cancelar',
    galleryImages: 'Imágenes de la Galería',
    profilePicture: 'Foto de Perfil',
    imageNotUploaded: '¡Imagen no cargada!',
    useCamera: 'Usar Cámara',
    removeAccountError: 'No se pudo eliminar la cuenta, intente nuevamente.',
    removeAccountSure: '¿Estás seguro de que deseas eliminar tu cuenta?',
    removeAccountInfo: 'Al eliminar tu cuenta, perderás todos los tickets que poseas actualmente.',
    removeAccount: 'Eliminar cuenta',
    personalData: 'DATOS PERSONALES',
    atLeastThreeCharacters: 'Mínimo 3 caracteres',
    firstname: 'Nombre',
    lastname: 'Apellido',
    email: 'Correo Electrónico',
    dateOfBirthday: 'Fecha de Nacimiento (Opcional)',
    phone: 'Teléfono (Opcional)',
    address: 'Dirección',
    city: 'Ciudad',
    state: 'Estado',
    country: 'País',
    location: 'UBICACIÓN',
    paypalAccount: 'Paypal Account',
    /**
     * Organizer publish page
     */
    transaction: 'Transacción',
    transactionPublished: 'Transacción publicada exitosamente',
    transactionNotPublished: 'No se pudo publicar la transacción',
    transactionProcessing: '¡La transacción se está procesando actualmente, por favor espere!',
    /**
     * Register page
     */
    invalidPassword: 'La contraseña debe tener al menos 8 caracteres, incluyendo al menos una letra minúscula, una letra mayúscula y un número.',
    invalidUsername: 'Los nombres de usuario deben tener al menos 3 caracteres y pueden contener letras mayúsculas y minúsculas del alfabeto latino, números, guiones y guiones bajos.',
    letsGetOnBoard: '¡Subamos a bordo!',
    enterValidUsername: 'Ingresa un nombre de usuario válido *',
    enterValidFirstname: 'Ingresa un nombre válido *',
    enterValidLastname: 'Ingresa un apellido válido *',
    enterValidEmail: 'Ingresa un correo electrónico válido *',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    /**
     * Tickets overview page
     */
    start: 'Comenzar',
    seating: 'Asientos',
    date: 'Fecha',
    edit: 'Editar',
    ticketInvalidated: 'Este ticket ya ha sido escaneado y utilizado.',
    dateOfSale: 'Fecha de venta',
    price: 'Precio',
    expirationDate: 'Fecha de vencimiento',
    removeFromMarketPlace: 'Eliminar del Mercado',
    activateConfirmTitle: '¿Estás seguro de que deseas activar este ticket?',
    activateConfirmText: 'Una vez activado, no podrás desactivarlo, transferirlo ni venderlo.',
    activateTicket: 'Activar Ticket',
    ticketIsProcessed: 'Tu ticket aún se está procesando: una vez emitido, podrás transferirlo, venderlo y activarlo.',
    moreInfo: 'Más información',
    swipeEventDetails: 'Desliza para ver los detalles del evento',
    /**
     * Single Ticket screen
     */
    qrCode: 'Código QR',
    ticketCantActivate: 'El código QR del boleto permanece bloqueado hasta siete días antes del evento.',
    ticketActivateFirst: 'Para mostrar el código QR, primero debe activarse el boleto.',
    ticketCantActivateEnded: 'No puedes activar el boleto después de que el evento haya pasado.',
    showQrCodeAtEntrance: 'Muestra el código QR en la entrada para acceder al evento.',
    options: 'Opciones',
    transferTicketsToFriends: 'Transfiere boletos a tus amigos sin costo o véndelos en nuestro mercado secundario seguro.',
    ticket: 'Boleto',
    discount: 'Descuento',
    dateAndLocation: 'Fecha y Ubicación',
    ticketHolder: 'Titular del boleto',
    ticketDetails: 'Detalles del boleto',
    readMore: 'Leer más',
    eventDetails: 'Detalles del evento',
    buyTickets: 'Comprar boletos',
    detailsAboutTicket: 'Detalles sobre el boleto',
    detailsAboutEvent: 'Detalles sobre este evento',
    /**
     * Form input component
     */
    gender: 'Género (Opcional)',
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
    /**
     * Wallet page
     */
    exportShareMessage: 'Guarda tu billetera en un lugar seguro:',
    backupWallet: 'Respaldar Billetera',
    backup: 'Respaldar',
    backupText: 'Aún no has respaldado tu billetera, por favor crea un respaldo en caso de que necesites recuperar tu billetera.',
    backupIncomplete: 'Respaldo incompleto',
    backupComplete: 'Respaldo completado',
    backupSuccessTitle: 'Tu billetera ha sido respaldada exitosamente.',
    backupSuccessInfo: 'Por favor, mantén tu billetera segura. No la compartas con otros, ya que representa tu identidad en la blockchain.',
    permissionDenied: 'Permiso denegado, inténtalo de nuevo',
    shareMessage: '¡Compartamos algunas entradas! Aquí está mi',
    copied: 'Copiado',
    add: 'Agregar',
    connectedWallets: 'Billeteras Conectadas',
    connectYourWallet: 'Conecta tu billetera',
    connectYourWalletInfo: 'Si aún no tienes una billetera, puedes seleccionar un proveedor, descargar la aplicación y crear una ahora.',
    metamask: 'Metamask',
    to: 'a',
    the: 'la',
    downloads: 'Descargas',
    folder: 'carpeta',
    /**
     * Offline page
     */
    offlineHeader: 'Sin conexión',
    offlineText: 'Actualmente estás sin conexión.',
    offlineSecondText: 'Es posible que algunas funciones no estén disponibles.',
    /**
     * Home page
     */
    tickets: 'Entradas',
    pastExperience: 'Experiencias pasadas',
    upcoming: 'Próximos',
    noTickets: 'Aún no tienes ninguna entrada.',
    checkOutOur: 'Echa un vistazo a nuestro ',
    ticketMarketplace: 'Mercado de Entradas',
    toGetThem: ' para conseguirlas.',
    /**
     * Transfer page
     */
    transferTicket: 'Transferir Entradas',
    transferTicketDescription: 'Escanee un código QR o ingrese la ID de billetera del destinatario para seleccionar y transferir entradas.',
    bamWalletShareTitleStart: '¡Tu amigo aún no tiene la aplicación ',
    bamWalletShareTitleEnd: '!',
    bamWalletShareSubTitleStart: 'Invita a tus amigos y comparte la aplicación ',
    bamWalletShareSubTitleEnd: ' con ellos para facilitar la transferencia de entradas.',
    enterWalletId: 'ID de Billetera del Destinatario',
    walletIdError: 'Usuario no encontrado / ID incompleta',
    share: 'Compartir',
    transfer: 'Transferir',
    sell: 'Vender',
    sellTicket: 'Vender Entrada',
    walletId: 'ID de Billetera',
    transferModalSbtitle: 'Una vez transferidas, las entradas se eliminarán de tu billetera.',
    shareModalTitleStart: 'Compartir ',
    shareModalTitleEnd: ' con un amigo',
    succesTransferMessageTile: 'Entrada(s) transferida(s)',
    errorTransferMessageTile: 'Error en la transferencia de entrada(s)',
    succesTransferMessage: 'Tus entrada(s) se han transferido correctamente. Ya no están disponibles en tu billetera.',
    errorTransferMessage: 'Hubo un error. Por favor, inténtalo de nuevo más tarde.',
    done: 'Hecho',
    areYouSureTransfer: '¿Estás seguro de que quieres transferir',
    ticketsTo: 'entrada(s) a',
    tryAgain: 'Intentar de nuevo',
    findUser: 'Buscar usuario',
    emailOrWalletId: 'Correo electrónico o ID de monedero',
    emailDoesNotExist: 'No podemos encontrar un usuario con este correo electrónico. Verifique el correo electrónico o presione "Invitar" para invitar al usuario y transferir boletos.',
    invite: 'Invitar',
    selectTicketsToTransfer: 'Seleccione boletos para transferir a: ',
    transferring: 'Transfiriendo ',
    transferringTickets: ' boleto(s).',
    okay: 'Aceptar',
    sureCancelTransferTo: '¿Estás seguro de que quieres cancelar la transferencia a ',
    ifYouCancelNowRepeatLater: 'Si cancelas el proceso de transferencia ahora, podrás repetirlo más tarde.',
    cancelTransfer: 'Cancelar transferencia',
    backToTickets: 'Volver a los boletos',
    successSentInvite: 'Has enviado correctamente una invitación a un usuario.',
    ableToTransferTicketsNow: 'Podrás transferir boleto(s) al usuario ahora.',
    /**
     * Qrcode Scanner
     */
    qrcodeScannerScreenTitle: 'Escanear Billetera',
    scanWallet: 'Escanear Billetera',
    /**
     * Ticket holder information
     */
    cancelSureTitle: '¿Estás seguro de que quieres cancelar?',
    cancelSureText: 'Asegúrate de guardar todos los cambios antes de salir del proceso.',
    confirm: 'Confirmar',
    /**
     * Sell ticket
     */
    sellTickets: 'Vender Entradas',
    setExpiration: 'Establecer Fecha de Expiración',
    ticketPrice: 'Precio de la Entrada',
    sellTicketConfirmTitle: '¿Estás seguro de que quieres vender tu entrada en el Mercado Secundario?',
    sellTicketConfirmMessage: 'Podrás acceder a la(s) entrada(s) desde tu billetera y cancelar la venta.',
    succesSellTile: 'Entrada(s) publicada(s) en el Mercado',
    succesSellMessage: 'Tu(s) entrada(s) se ha(n) publicado correctamente en el Mercado Secundario.',
    errorSellTitle: 'Error al vender el boleto',
    errorSellMessage: 'Se produjo un error al intentar publicar su boleto en venta. Por favor, inténtelo de nuevo.',
    sellFeeHintStart: 'El organizador cobra una tarifa del',
    sellFeeHintMiddle: '% sobre la venta para este evento. Recibirás',
    sellNoFeeHint: 'El organizador no cobra ninguna tarifa sobre la venta para este evento. Recibirás',
    setExpirationDate: 'Establecer fecha de vencimiento',
    payout: 'Pago',
    payoutHintText1: 'Por favor, proporcione una cuenta de PayPal o una dirección de correo electrónico que se utilizará para el pago.',
    payoutHintText2: 'Los pagos se realizan automáticamente a través de PayPal una vez que su boleto se venda. Recibirá una notificación por correo electrónico después de que se procese la venta.',
    payoutHintText3: '¡Gracias por usar nuestra plataforma! Si tiene alguna pregunta, comuníquese con nuestro equipo de soporte.',
    publishingTicketToSecondaryMarket: 'Publicando su(s) boleto(s) en el Mercado Secundario.',
    /**
* Bottom menu
*/
    nft: 'NFT',
    profile: 'Perfil',
    /**
     * NFT screen
     */
    myCollection: 'Mi Colección',
    noNFTsYet: 'Aún no tienes NFTs',
    doNotSeeNFT: '¿No ves tu NFT?',
    importNFTs: 'Importar NFTs',
    description: 'Descripción',
    chain: 'Cadena',
    /**
   * Metamask wallets screen
   */
    selectWallet: 'Seleccionar Billetera',
    connectedAddresses: 'Direcciones Conectadas',
    confirmRemoveWalletTitle: '¿Estás seguro de que quieres eliminar esta dirección?',
    confirmRemoveWalletText: 'Si eliminas esta dirección, todos tus NFTs conectados serán eliminados.',
    removeAddress: 'Eliminar Dirección',
    /**
     * Metamask add component
     */
    metamaskWalletConnectSuccessTitle: 'Billetera de Metamask conectada.',
    metamaskWalletConnectSuccessText: 'Tu billetera de Metamask se ha agregado correctamente.',
    metamaskWalletConnectErrorTitle: 'Error de la billetera de Metamask.',
    metamaskWalletConnectErrorText: 'No se pudo agregar la billetera de Metamask.',
    /**
     * App screen
     */
    applicationUpdateTitle: 'Actualización de la aplicación requerida.',
    applicationUpdateText: 'Hay disponible una nueva versión de la aplicación y es necesario actualizarla para continuar. Haz clic a continuación para actualizar a la última versión.',
    update: 'Actualizar',
    understand: 'Entiendo',
    /**
     * Settings
     */
    settings: 'Configuración',
    notifications: 'Notificaciones',
    enableNotifications: 'Activar notificaciones',
    eventStart: 'Inicio del evento',
    checkIn: 'Check-In',
    none: 'Ninguno',
    minutes: 'minutos',
    hour: 'hora',
    fiveMinutesBefore: '5 minutos antes',
    tenMinutesBefore: '10 minutos antes',
    fifteenMinutesBefore: '15 minutos antes',
    thirtyMinutesBefore: '30 minutos antes',
    fourtyFiveMinutesBefore: '45 minutos antes',
    oneHourBefore: '1 hora antes',
    fiveMinutes: '5 minutos',
    tenMinutes: '10 minutos',
    fifteenMinutes: '15 minutos',
    thirtyMinutes: '30 minutos',
    fourtyFiveMinutes: '45 minutos',
    oneHour: '1 hora',
    language: 'Idioma',
    bs: 'Bosnio',
    de: 'Alemán',
    en: 'Inglés',
    es: 'Español',
    fr: 'Francés',
    sr: 'Serbio',
    this: 'Esta',
    is: 'es',
    near: 'cerca',
    /**
     * Notificaciones
     */
    today: 'Hoy',
    clear: 'Limpiar',
    noNewNotifications: 'Sin nuevas notificaciones',
    noNewNotificationsHint: '¡Estás al día! Vuelve más tarde para ver nuevas notificaciones.',
    /**
     * Validator App
     */
    /**
     * Login screen
     */
    welcome: 'Welcome',
    scanQrCodeHint: 'Use the QR code shown in your organizer dashboard to login.',
    scanQrCode: 'Scan QR code',
    switchedEnvironment: 'Switched Environment',
    switchedEnvironmentToProd: 'Switched environment to prod',
    switchedEnvironmentToDev: 'Switched environment to dev',
    appVersion: 'App Version',
    /**
     * Login-Scan screen
     */
    qrCodeScannerHint: 'Please scan the organizer QR code to login.',
    loginQrErrorTitle: 'Login failed.',
    loginQrError: 'Please use the correct organiser QR code from the admin dashboard.',
    loginLoading: "Almost done. Please don't exit the application until information is loaded.",
    /**
     * Ticket-Scan screen
     */
    tapToStartScanning: 'Tap to start scanning',
    validTicket: 'Check-In successful!',
    invalidTicket: 'Invalid Ticket!',
    scannedAt: 'Scanned at',
    venueInfoError: 'Unable to fetch venue information',
    signingKeyError: 'Unable to fetch signing key',
    eventInfoError: 'Unable to fetch event information',
    ticketQrError: 'Unable to scan QR-Code',
    scanTickets: 'Scan Tickets',
    ticketCountError: 'Unable to fetch amount of scanned tickets',
    scanAgain: 'Scan again',
    signOutTitle: 'Are you sure you want to Sign Out?',
    signOutText: 'Make sure you saved all the changes you made before signing out.',
    logout: 'Logout',
    checkedIn: 'Checked-in:',
    of: 'of',
    validatingTicket: 'Validating ticket.',
};
//# sourceMappingURL=es.js.map